import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectQuizFilters, setQuizFilters} from './slice';

import type {QuizzesFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';
export function useQuizFilters(
  location: Location<QuizzesFetchParamsType>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectQuizFilters,
    useAsyncActions({
      setQuizFilters,
    }).setQuizFilters,
    convertLocationParamsToFetchParams
  );
}
